// ── Canonical theme data — single source of truth for API (browse.js) and frontend ──

export const THEME_META = {
  hikma: {
    icon: '⚖️',
    nameAr: 'الحكمة',
    nameEn: 'Wisdom & Aphorisms',
    desc: 'Timeless maxims and moral philosophy from the masters of classical Arabic verse.',
    level: 'B1',
  },
  ghazal: {
    icon: '🌹',
    nameAr: 'الغزل',
    nameEn: 'Love & Longing',
    desc: 'The ache of separation and the beauty of the beloved — the oldest voice in Arabic verse.',
    level: 'A2',
  },
  sufi: {
    icon: '🌙',
    nameAr: 'الصوفية',
    nameEn: 'Sufi & Mystical Poetry',
    desc: "The soul's yearning for the divine — verse as spiritual contemplation and inner journey.",
    level: 'B2',
  },
  fakhr: {
    icon: '⚔️',
    nameAr: 'الفخر',
    nameEn: 'Heroism & Pride',
    desc: 'Battle odes and tribal glory from the age of the warrior-poets of the Arabian peninsula.',
    level: 'B2',
  },
  ritha: {
    icon: '🕊️',
    nameAr: 'الرثاء',
    nameEn: 'Elegy & Lamentation',
    desc: 'Grief immortalised — elegies that have moved hearts across fourteen centuries.',
    level: 'B1',
  },
  zuhd: {
    icon: '📿',
    nameAr: 'الزهد',
    nameEn: 'Zuhd & Asceticism',
    desc: 'Renunciation of the world and the contemplation of mortality in verse.',
    level: 'B2',
  },
  wasf: {
    icon: '🌿',
    nameAr: 'الوصف',
    nameEn: 'Nature & Description',
    desc: 'Vivid portraits of gardens, rivers, deserts, and the night sky in breathtaking detail.',
    level: 'A2',
  },
  madih: {
    icon: '👑',
    nameAr: 'المديح',
    nameEn: 'Praise Poetry',
    desc: 'Panegyrics celebrating caliphs, generals, and noble patrons of the literary arts.',
    level: 'B2',
  },
  karam: {
    icon: '🤲',
    nameAr: 'الكرم والجود',
    nameEn: 'Generosity & Nobility',
    desc: 'Verse honouring the open hand and the generous spirit — the Arab virtue of jūd immortalised in poetry.',
    level: 'B1',
  },
  hija: {
    icon: '⚡',
    nameAr: 'الهجاء',
    nameEn: 'Satire',
    desc: 'Cutting wit and biting verse — poetry wielded as a weapon of honour and tribal rivalry.',
    level: 'C1',
  },
  muallaqat: {
    icon: '📜',
    nameAr: 'المعلقات',
    nameEn: 'The Muʿallaqāt',
    desc: 'The seven golden odes of pre-Islamic Arabia — the pinnacle of the classical tradition, said to have been hung in the Kaaba.',
    level: 'C1',
  },
  shawq: {
    icon: '💌',
    nameAr: 'الشوق والعتاب',
    nameEn: 'Longing & Reproach',
    desc: 'The ache of absence — poems of yearning for the distant beloved, tender reproach, and the grief of separation.',
    level: 'B1',
  },
};

// Arabic topic tags as stored in the DB — used by browse.js to filter poems by theme.
export const THEME_TOPICS = {
  hikma:     ['قصائد نصيحة', 'قصائد حكمة', 'قصائد عامه'],
  ghazal:    ['قصائد رومنسيه', 'قصائد غزل'],
  sufi:      ['قصائد دينية', 'قصائد ابتهال'],
  fakhr:     ['قصائد فخر', 'قصائد عامه', 'قصائد حماسة'],
  ritha:     ['قصائد رثاء', 'قصائد حزينه'],
  zuhd:      ['قصائد زهد', 'قصائد دينية', 'قصائد نصيحة', 'قصائد صبر'],
  wasf:      ['قصائد قصيره', 'قصائد وصف'],
  madih:     ['قصائد مدح'],
  karam:     ['قصائد جود وكرم'],
  hija:      ['قصائد هجاء', 'قصائد ذم'],
  muallaqat: ['قصائد المعلقات'],
  shawq:     ['قصائد شوق', 'قصائد فراق', 'قصائد عتاب'],
};
